import { defineStore, storeToRefs } from 'pinia'
import { authStore } from './auth'

export const useGeneralStore = defineStore('GeneralStore', {
  persist: {
    storage: persistedState.localStorage,
  },
  state: () => ({
    isTouchDevice: false,
    isLoggedIn: false,
    contextId: 0,
    titlePage: 'Home',
    contextInfo: [],
    breadItems: [],
    cities: [],
    systemConfig: [],
    windowWidth: null,
  }),
  actions: {
    hasCapability(capability, contextid) {
      const { data } = storeToRefs(authStore()) 
      const findContext = contextid ?? this.contextId
      
      const currentContext = Object.values(data.value.context).find(p =>
        (findContext === 0) ? p.info.CNTX_type === 'site' : parseInt(p.info.CNTX_PK) === parseInt(findContext),
      )
      
      return currentContext ? currentContext.capabilities.some(p => p.CPBL_name === capability) : false
    },
    setContext (id) {
      const { data } = storeToRefs(authStore())

      this.contextId = id
      this.titlePage = 'Home'
    
      if (data.value && data.value.context && data.value.context[id]) {
        this.contextInfo = data.value.context[id].info
      }
    },
    addBread (item) {
      const itemIndex = this.breadItems.findIndex(p => p.order === item.order)
      if (itemIndex >= 0) {
        this.breadItems[itemIndex] = { ...this.breadItems[itemIndex], ...item }
      } else {
        this.breadItems.push(item)
      }
    },
    unsetBread (order) {
      this.breadItems = this.breadItems.filter(p => p.order <= order)
    },
    clearBread () {
      this.breadItems = []
    },
    cleanCities () {
      this.cities = []
    },
    fetchCities () {
      if(this.cities.length === 0){
        return new Promise((resolve, reject) => {
          $api('cities/get')
            .then(response => {
              this.cities = response
              resolve(response)
            })
            .catch(reject)
        })
      }
    },
    fetchConfig (param) {
      return new Promise((resolve, reject) => {
        const paramstr = typeof param !== 'undefined' ? ('?param='+param):''
 
        $api('config/get'+paramstr)
          .then(response => {
            if(Array.isArray(response.data.data)){
              response.data.data.forEach(element => {
                const cgfIndex = this.systemConfig.findIndex(p=> p.CNFG_name===element.CNFG_name)
                if(cgfIndex>=0){
                  this.systemConfig[cgfIndex] = element
                }else{
                  this.systemConfig.push(element)
                }
              })
            }
            else if(typeof response.data.data === 'object' && response.data.data !== null){
              const cgfIndex = this.systemConfig.findIndex(p=> p.CNFG_name===response.data.data.CNFG_name)
              if(cgfIndex>=0){
                this.systemConfig[cgfIndex] = element
              }else{
                this.systemConfig.push(response.data.data)
              }
            }
            resolve(response)
          })
          .catch(reject)
      })
    },
    getConfig(configName) {
      if (Array.isArray(this.systemConfig) && typeof this.systemConfig.find === 'function') {
        const config = this.systemConfig.find(p => p.CNFG_name === configName)

        return config ? config.CNFG_value : ''
      }
      
      return ''
    },
    saveConfig(config){
      return new Promise((resolve, reject) => {
        $api('config/save', { body: { 'cfg': config } })
          .then(response => {
            response.data.map(p=>{
              const configIndex = this.systemConfig.findIndex(q => p.CNFG_name === q.CNFG_name)

              Object.assign(this.systemConfig[configIndex], p)
            })

            resolve(response.data)
          })
          .catch(reject)
      })
    },
    citiesSelect() {
      return this.cities.map(c => ({ value: c.CITY_PK, title: `${c.STTE_name}/${c.CITY_name}`, hood: c.hood.map(d => ({ value: d.HOOD_PK, title: d.HOOD_name })) }))
    },
    getCity(cityId) {
      if (Array.isArray(this.cities) && typeof this.cities.find === 'function') {
        return this.cities.find(p => p.CITY_PK === cityId) || ''
      }
    
      return ''
    },
    addContext (info) {
      const { data } = storeToRefs(authStore())
      if (data.value.context && !data.value.context[info.CNTX_PK]) {
        data.value.context[info.CNTX_PK] = { info }
      }
    },
  },
})

/*
actions: {
  isTouchDevice (){
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
    
    const mq = query => {
      return false // window.matchMedia(query).matches
      }
      
    
      
      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
      
    return mq(query)
    },
    scrollbarTag() {
    return this.is_touch_device ? 'div' : 'PerfectScrollbar '
  },

  getContext() {
    return data.context[this.context]
  },

  contextCapabilities(contextid){
    const findContext = (!contextid) ? ((this.contextId ?? 0)) : contextid
  
    const currentContext = Object.values(data.context)[Object.values(data.context).findIndex(p =>
      (findContext === 0) ? p.info.CNTX_type === 'site' : parseInt(p.info.CNTX_PK) === parseInt(findContext),
    )]
  
      
    return currentContext ? currentContext.capabilities : false
  },
  setContext (id) {
    commit('SET_CONTEXT', id)
  },

  
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////
  
  // Vertical NavMenu
  updateVerticalNavMenuWidth (width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },
  
  // VxAutoSuggest
  updateStarredPage (payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },
  
  // The Navbar
  arrangeStarredPagesLimited (list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore (list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },
  
  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////
  
  toggleContentOverlay () {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme (val) {
    commit('UPDATE_THEME', val)
  },
},*/


/*const mutations = {  
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////
  
  // Vertical NavMenu
  
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    this.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    this.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    this.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    this.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    this.verticalNavMenuWidth = width
  },
  
  // VxAutoSuggest
  
  UPDATE_STARRED_PAGE (state, payload) {
    // find item index in search list state
    const index = this.navbarSearchAndPinList.pages.data.findIndex(item => item.url === payload.url)
  
    // update the main list
    this.navbarSearchAndPinList.pages.data[index].is_bookmarked = payload.val
  
    // if val is true add it to starred else remove
    if (payload.val) {
      this.starredPages.push(this.navbarSearchAndPinList.pages.data[index])
    } else {
      // find item index from starred pages
      const index = this.starredPages.findIndex(item => item.url === payload.url)
  
      // remove item using index
      this.starredPages.splice(index, 1)
    }
  },
  
  // Navbar-Vertical
  
  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = this.starredPages.slice(10)
  
    this.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp = false
    const lastItemInStarredLimited = this.starredPages[10]
    const starredPagesLimited = this.starredPages.slice(0, 10)
  
    this.starredPages = starredPagesLimited.concat(list)
  
    this.starredPages.slice(0, 10).map(i => {
      if (list.includes(i)) { downToUp = true }
    })
  
    if (!downToUp) {
      this.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },
  
  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////
  
  TOGGLE_CONTENT_OVERLAY (state, val) { this.bodyOverlay = val },
  UPDATE_PRIMARY_COLOR (state, val) { this.themePrimaryColor = val },
  UPDATE_THEME (state, val) { this.theme = val },
  UPDATE_WINDOW_WIDTH (state, width) { this.windowWidth = width },
  UPDATE_WINDOW_SCROLL_Y (state, val) { this.scrollY = val },
}*/
